import { render } from "./CustomInputUploadImage.vue?vue&type=template&id=0b681b61&scoped=true"
import script from "./CustomInputUploadImage.vue?vue&type=script&lang=js"
export * from "./CustomInputUploadImage.vue?vue&type=script&lang=js"

import "./CustomInputUploadImage.vue?vue&type=style&index=0&id=0b681b61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b681b61"]])

export default __exports__